document.addEventListener('DOMContentLoaded', function () {
  const variantOptionGroups = document.querySelectorAll('.variant-options');
  const allVariants = document.querySelectorAll('.variant-pill');
  const hiddenVariantSelect = document.getElementById('hidden-variant-select');
  
  if (allVariants.length === 0 && hiddenVariantSelect) {
    const firstHiddenOption = hiddenVariantSelect.querySelector('option');
    if (firstHiddenOption) {
      firstHiddenOption.selected = true;

      const variantId = firstHiddenOption.dataset.variantId;
      const variantImage = firstHiddenOption.dataset.varaiantImage;

      document.getElementById('variant-id').value = variantId;
      document.getElementById('buy-now-variant-id').value = variantId;

      updateMediaForSelectedVariant(variantImage);
    }
  } else {
    if (allVariants.length > 0) {
      variantOptionGroups.forEach(group => {
        const firstOption = group.querySelector('.variant-pill');
        if (firstOption) {
          firstOption.classList.add('selected');
        }
      });

      const firstVariantOption = hiddenVariantSelect.querySelector('option');
      if (firstVariantOption) {
        const firstVariantId = firstVariantOption.dataset.variantId;
        const firstVariantImage = firstVariantOption.dataset.varaiantImage;

        document.getElementById('variant-id').value = firstVariantId;
        document.getElementById('buy-now-variant-id').value = firstVariantId;

        updateMediaForSelectedVariant(firstVariantImage);
      }
    }
  }

  const variantOptions = document.querySelectorAll('.variant-pill, .variant-dropdown');
  const variantIdInput = document.getElementById('variant-id');
  const buyNowVariantId = document.getElementById('buy-now-variant-id');
  
  let selectedOptions = {};

  function updateSelectedVariant() {
    let matchedVariant = Array.from(hiddenVariantSelect.options).find(opt => {
      return Object.keys(selectedOptions).every((key, index) => opt.dataset[`option-${index + 1}`] === selectedOptions[key]);
    });

    if (matchedVariant) {
      const variantId = matchedVariant.dataset.variantId;
      const variantImage = matchedVariant.dataset.varaiantImage;
  
      variantIdInput.value = variantId;
      buyNowVariantId.value = variantId;

      updateMediaForSelectedVariant(variantImage);
    } else {
      console.log('No matched variant found.');
    }
  }

  variantOptions.forEach(option => {
    option.addEventListener('click', function () {
      const optionName = this.dataset.optionName || this.getAttribute('data-option-name');
      const optionValue = this.dataset.optionValue || this.value;

      selectedOptions[optionName] = optionValue;
      document.querySelectorAll(`[data-option-name='${optionName}']`).forEach(el => el.classList.remove('selected'));
      this.classList.add('selected');
      updateSelectedVariant();
    });
  });

  function updateMediaForSelectedVariant(variantImageSrc) {

    if (!variantImageSrc) return;
    const mediaLayout = document.getElementById('media-layout-info').getAttribute('data-layout');

    if (['slider', 'bottom', 'left', 'right'].includes(mediaLayout)) {
      const sliderClasses = [
        '.product-slider-bottom-nav', '.product-slider-bottom-for',
        '.product-slider-left-nav', '.product-slider-left-for',
        '.product-slider-right-nav', '.product-slider-right-for',
        '.product-slider'
      ];

      sliderClasses.forEach(sliderClass => {
        const slides = document.querySelectorAll(`${sliderClass} .slick-slide`);
        let slideIndex = -1;

        slides.forEach((slide, index) => {
          const image = slide.querySelector('img');
          if (image && image.getAttribute('src') === variantImageSrc) {
            slideIndex = slide.getAttribute('data-slick-index');
          }
        });

        if (slideIndex !== -1) {
          const slickSlider = document.querySelector(sliderClass);
          if (slickSlider && typeof $(slickSlider).slick === 'function') {
            $(sliderClass).slick('slickGoTo', parseInt(slideIndex));
          }
        }
      });
    }

    if (['sticky', 'image', 'video'].includes(mediaLayout)) {
      const parentSelectors = ['.product-sticky', '.product-video', '.product-image'];

      parentSelectors.forEach(parentSelector => {
        const parentElement = document.querySelector(parentSelector);
        if (!parentElement) return; 

        const images = parentElement.querySelectorAll('img');
        images.forEach(image => {
          if (image.getAttribute('src') === variantImageSrc) {
            window.scrollTo({ top: image.offsetTop + 100, behavior: 'smooth' });
          }
        });
      });
    }
  }

  
  const minusBtn = document.getElementById("minus-btn");
  const plusBtn = document.getElementById("plus-btn");
  const qtyInput = document.getElementById("quantity");
  const cartQtyInput = document.getElementById("cart-quantity");
  const paymentQtyInput = document.getElementById("payment-quantity");
  const priceEl = document.getElementById("cart-price");
    const discountRadios = document.querySelectorAll(".discount_radio");

  if (!qtyInput) return;
  function syncQuantity(value) {
    const qty = Math.max(1, value);

    qtyInput.value = qty;
    cartQtyInput && (cartQtyInput.value = qty);
    paymentQtyInput && (paymentQtyInput.value = qty);

    updatePrice();
  }
    if (discountRadios.length > 0) {
    discountRadios.forEach(radio => {
      radio.addEventListener("change", () => {
        syncQuantity(parseInt(radio.value) || 1);
      });
    });
  }
  function formatMoney(cents) {
    const amount = cents / 100;
    const activeCurrency = window?.Shopify?.currency?.active || "USD";

    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: activeCurrency,
      currencyDisplay: "narrowSymbol",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  }
  function updatePrice() {
    if (!priceEl) return;

    const basePrice = parseInt(priceEl.dataset.basePrice || 0, 10);
    const qty = parseInt(qtyInput.value || 1, 10);
    const total = basePrice * qty;

    priceEl.textContent = formatMoney(total);
  }

  plusBtn?.addEventListener("click", function () {
    const current = parseInt(qtyInput.value || 1, 10);
    syncQuantity(current + 1);
  });

  minusBtn?.addEventListener("click", function () {
    const current = parseInt(qtyInput.value || 1, 10);
    if (current > 1) {
      syncQuantity(current - 1);
    }
  });

  qtyInput.addEventListener("change", () => {
    syncQuantity(parseInt(qtyInput.value || 1, 10));
  });
  updatePrice();
});

document.addEventListener('DOMContentLoaded', () => {
  const updateLabel = (name, value) => {
    const span = document.querySelector(`#selected-${name.toLowerCase().replace(/\s+/g, '-')}`);
    if (span) span.textContent = value;
  };

  const handleClick = (el, group, name, value) => {
    document.querySelectorAll(`[data-option-name="${name}"]`).forEach(e => e.classList.remove('active'));
    el.classList.add('active');
    updateLabel(name, value);
  };

  document.querySelectorAll('[class*="variant-"]').forEach(el => {
    const name = el.dataset.optionName;
    const isInput = el.tagName === 'INPUT';

    el.addEventListener(isInput ? 'change' : 'click', () => {
      const value = isInput ? el.value : el.dataset.optionValue || el.value;
      if (!name || !value) return;

      if (el.classList.contains('variant-dropdown')) updateLabel(name, value);
      else handleClick(el, el.className, name, value);
    });
  });
});
